// Teil „Ausgang“ des Manifests (Paket UI-Ausgang): die Liste der ausgestellten XRechnungen unter Finanzen und die
// Einstellungen der E-Rechnung im Einstellungsbereich. Lesen nutzt bewusst die Rechte der Finanzen (SPEZIFIKATION
// §10.2: wer die Rechnung sieht, sieht ihre XML). In Node ladbar: Seiten nur per lazy-Import.
import type { WebModuleSpec } from '@web/module'
import { FileCheck, FileCode, Settings2 } from 'lucide-react'

const OUTBOUND_READ = 'finance.invoice.read'
const SETTINGS_READ = 'platform.settings.read'

export const OUTBOUND_PATH = '/einvoice/outbound'
export const SETTINGS_PATH = '/settings/einvoice'

/** Ziel eines Suchtreffers bzw. Verweises auf eine ausgestellte E-Rechnung: die Liste mit geöffneter Ansicht. */
export const outboundHref = (outboundId: string): string =>
  `${OUTBOUND_PATH}?outbound=${encodeURIComponent(outboundId)}`

export const outbound: Omit<WebModuleSpec, 'id'> = {
  routes: [
    {
      path: OUTBOUND_PATH,
      title: 'E-Rechnungen im Ausgang',
      permission: OUTBOUND_READ,
      lazy: () => import('../pages/OutboundPage'),
    },
    {
      path: SETTINGS_PATH,
      title: 'E-Rechnung',
      permission: SETTINGS_READ,
      lazy: () => import('../pages/EInvoiceSettingsPage'),
    },
  ],
  nav: [
    {
      section: 'finance',
      label: 'E-Rechnungen (Ausgang)',
      icon: FileCode,
      to: OUTBOUND_PATH,
      permission: OUTBOUND_READ,
      order: 15,
    },
    {
      section: 'settings',
      label: 'E-Rechnung',
      icon: FileCheck,
      to: SETTINGS_PATH,
      permission: SETTINGS_READ,
      order: 60,
    },
  ],
  commands: [
    {
      id: 'einvoice.outbound',
      label: 'Ausgestellte E-Rechnungen anzeigen',
      keywords: ['XRechnung', 'E-Rechnung herunterladen', 'XML', 'übermittelt', 'Ausgang'],
      icon: FileCode,
      to: OUTBOUND_PATH,
      permission: OUTBOUND_READ,
    },
    {
      id: 'einvoice.outbound.undelivered',
      label: 'Noch nicht übermittelte E-Rechnungen',
      keywords: ['XRechnung', 'nicht versandt', 'offen', 'übermitteln'],
      icon: FileCode,
      to: `${OUTBOUND_PATH}?f.undelivered=1`,
      permission: OUTBOUND_READ,
    },
    {
      id: 'einvoice.settings',
      label: 'Einstellungen: E-Rechnung',
      keywords: ['Einstellungen', 'Stichtag', 'XRechnung', 'UBL', 'CII', 'Bereit für E-Rechnungen'],
      icon: Settings2,
      to: SETTINGS_PATH,
      permission: SETTINGS_READ,
    },
  ],
  searchResults: {
    einvoice_outbound: { label: 'E-Rechnungen', icon: FileCode, to: (hit) => outboundHref(hit.id) },
  },
  entityLinks: {
    einvoice_outbound: (id) => outboundHref(id),
    einvoice_setting: () => SETTINGS_PATH,
  },
}
